import { isAddress } from 'viem'

/**
 * 给地址补 0x 前缀。
 *
 * 注意：这里**不再**把空值兜底成 '0x'。
 * 旧实现 `if (!address) return '0x'` 会把「地址缺失」伪装成一个看起来合法的地址，
 * 传进 viem 后报出来的是 `Address "0x" is invalid.`，完全看不出真正原因（是哪个地址为空）。
 * 现在直接抛出可读的错误，方便定位。
 */
export const to0xString = (address?: string | null): `0x${string}` => {
    if (!address) {
        throw new Error('地址为空：交易配置或代币地址缺失，请重新选择交易所/代币后再试');
    }
    return (address.startsWith('0x') ? address : `0x${address}`) as `0x${string}`;
};

/**
 * 前置校验：地址必须合法，否则带上字段名抛错。
 * 用于刷单等关键路径，避免拿空地址去发交易。
 */
export const checkAddress = (address: unknown, name = '地址'): `0x${string}` => {
    if (typeof address !== 'string' || !isAddress(address)) {
        throw new Error(`${name}缺失或非法（${String(address)}），请重新选择交易所/代币后再试`);
    }
    return address as `0x${string}`;
};
